import { Pipe, PipeTransform } from '@angular/core';
import { isPast } from 'date-fns';
import { stringOrDateToDate } from '../utilities/dateTime';

@Pipe({
  name: 'isPast',
  standalone: false,
})
export class IsPastPipe implements PipeTransform {
  public transform(value: string | Date): boolean {
    if (!value) {
      return false;
    }
    return isPast(stringOrDateToDate(value));
  }
}
